import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'order',
  getPageOnlineOrder (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageOnlineOrder`, queryParam)
  },
  getPageOnlineRefund (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageOnlineRefund`, queryParam)
  },
  getPageOfflineOrder (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageOfflineOrder`, queryParam)
  },
  getPageOfflineRefund (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageOfflineRefund`, queryParam)
  },
  getExportOnlineOrder (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/exportOnlineOrder`, queryParam)
  },
  getExportOnlineRefund (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/exportOnlineRefund`, queryParam)
  },
  getExportOfflineOrder (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/exportOfflineOrder`, queryParam)
  },
  getExportOfflineRefund (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/exportOfflineRefund`, queryParam)
  },
  getOrderPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageRefundApply`, queryParam)
  },
  handleOrder (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/handleRefundApply`, queryParam)
  },
  exportRefundApply (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/exportRefundApply`, queryParam)
  }
}
